module.exports = __webpack_public_path__ + "img/product_sk-ii_2.1967d732.png";